import { useEffect } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import invariant from 'tiny-invariant';

import { Link } from '../components/atomic/Link';
import { SideBar } from '../components/layout/side-bar/SideBar';
import { LoadingPage } from '../components/LoadingPage';
import { LocaleSwitch } from '../components/locale-switch/LocaleSwitch';
import { ThemeSwitch } from '../components/ThemeSwitch';
import { prefetchInvoiceResume } from '../hooks/useFetchInvoiceResume';
import { prefetchInvoiceResumeByMonth } from '../hooks/useFetchInvoiceResumeByMonth';
import { useFetchUser } from '../hooks/useFetchUser';
import { DriverOptionsProvider } from '../services/driver-options/DriverOptionsProvider';
import { t } from '../services/translation/translation';
import { formatDateForParisTZ } from '../utils/date';

export const MainLayout = () => {
  const { data: user, isLoading } = useFetchUser();

  useEffect(() => {
    prefetchInvoiceResume({});
    prefetchInvoiceResumeByMonth(formatDateForParisTZ(Date.now(), 'YYYY-MM-DD', false));
  }, []);

  if (isLoading) {
    return <LoadingPage />;
  }

  invariant(user);

  if (user.status === 'SUBSCRIPTION') {
    return <Navigate to="/subscription" />;
  }

  return (
    <div className="">
      <SideBar />
      <div className="p-4 sm:ml-64 sm:min-h-screen">
        {user.status === 'SUBSCRIPTION_REVIEW' ? (
          <div className="full p-4 mr-20 mb-2 text-sm text-yellow-800 rounded-lg bg-yellow-50 dark:bg-gray-800 dark:text-yellow-300">
            <span className="font-medium">{t('inactive-banner.title')}</span> {t('inactive-banner.caption')}{' '}
            <Link to="/company">{t('common.see-more')}</Link>
          </div>
        ) : null}
        <DriverOptionsProvider>
          <Outlet />
        </DriverOptionsProvider>
        <div className="absolute top-4 right-4 flex flex-row items-center gap-2">
          <ThemeSwitch />
          <LocaleSwitch />
        </div>
      </div>
    </div>
  );
};
